module.exports = "router-outlet {\n  height: 100%;\n}\n"